import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

const PrivateRoute = ({ component: Component, loggedIn, proxyLoggedIn, ...rest }) => (
  <Route {...rest} render={props => (
    loggedIn || proxyLoggedIn ?
      <Component {...props} /> :
      <Redirect to={{ pathname: '/keyman-letter-signin', state: { from: props.location } }} />
  )}
  />
)

PrivateRoute.propTypes = {
  component: PropTypes.any,
  loggedIn: PropTypes.any,
  proxyLoggedIn: PropTypes.any,
  location: PropTypes.any,
}

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/common/PrivateRoute.jsx